// CNC 파트너(제조사) 화면 — UI 구조용 샘플 데이터 (2026-10-23)
// 아직 서버 연결 없음. 나중에 outsourceOrders(flow 'mf', kind 'cnc') · jigJobs 로 교체한다.
// 치과명·환자명은 제조사 화면에 절대 넣지 않는다(기공소 거래처 보호).

const DAY = 24 * 60 * 60 * 1000;
const at = (dayOffset, hour = 10) => {
    const d = new Date();
    d.setHours(hour, 0, 0, 0);
    return new Date(d.getTime() + dayOffset * DAY);
};

export const SAMPLE_PARTNER = {
    companyName: '샘플 CNC 밀링센터',
    managerName: '김담당',
    approved: true,          // false 면 승인 대기 배너
};

// via = 유치 경로 — 제조사 직접 유치(direct) 또는 영업업체 소개(sales, 추천코드) (대표 10-23: 제조사도 기공소를 유치, 영업업체도 여러 곳 유치)
export const SAMPLE_LABS = [
    { id: 'lab1', code: 'L01', name: '가온치과기공소', joinedAt: at(-120), monthCount: 48, lastMonthCount: 41, via: { type: 'sales', salesId: 's1' } },
    { id: 'lab2', code: 'L02', name: '서울덴탈랩', joinedAt: at(-90), monthCount: 31, lastMonthCount: 35, via: { type: 'sales', salesId: 's1' } },
    { id: 'lab3', code: 'L03', name: '한빛기공소', joinedAt: at(-40), monthCount: 22, lastMonthCount: 12, via: { type: 'direct' } },
    { id: 'lab4', code: 'L04', name: '미소치과기공', joinedAt: at(-12), monthCount: 9, lastMonthCount: 0, via: { type: 'sales', salesId: 's2' } },
    { id: 'lab5', code: 'L05', name: '스마일랩', joinedAt: at(-3), monthCount: 2, lastMonthCount: 0, via: { type: 'direct' } },
]

const labName = (id) => (SAMPLE_LABS.find((l) => l.id === id) || {}).name || '—';

// status: received(접수) / milling(밀링 중) / shipped(출고)
// jig: ready / pending(생성 중) / failed(실패) / null(지그 없는 종류 — Metal 등)
// kind·detail·teeth·bridge·note = 기공소 외주 의뢰서(outsourceMfApi.createMfOrder)와 같은 키
const cnc = (system, connection, platform, diameter, extra = {}) => ({ item: '커스텀 어버트먼트', material: '티타늄(Gr.5)', system, connection, platform, diameter, ...extra });
const RAW = [
    { n: 1, lab: 'lab1', kind: 'cnc', teeth: '36', detail: cnc('Osstem TS III', 'Hex', 'Regular', '4.5'), status: 'received', jig: 'ready', recv: 0, due: 1, downloaded: false, note: '스크류홀 위치 협측으로 부탁드립니다.' },
    { n: 2, lab: 'lab2', kind: 'cnc', teeth: '46', detail: cnc('Straumann BLT', 'Hex', 'RC', '4.1', { anodizing: true, anodizingColor: '골드' }), status: 'received', jig: 'pending', recv: 0, due: 2, downloaded: false, note: '' },
    { n: 3, lab: 'lab1', kind: 'cnc', teeth: '26', detail: cnc('Dentium SuperLine', 'Non-hex', 'Regular', '5.0'), status: 'received', jig: 'failed', jigFail: '커넥션 라이브러리 불일치 (Dentium 4.5 ↔ 5.0)', recv: 0, due: 3, downloaded: false, note: '' },
    { n: 4, lab: 'lab3', kind: 'metal', teeth: '11,12,13', bridge: true, detail: { item: '프레임', material: 'CoCr', postProcess: '샌드블라스트', qty: 1 }, status: 'milling', jig: null, recv: -1, due: 0, downloaded: true, note: '전치부 — 마진 0.3mm 아래로' },
    { n: 5, lab: 'lab2', kind: 'cnc', teeth: '37', detail: cnc('Neo IS-III', 'Hex', 'Regular', '4.5', { material: '티타늄 프리밀드' }), status: 'milling', jig: 'ready', recv: -1, due: 1, downloaded: true, note: '' },
    { n: 6, lab: 'lab4', kind: 'metal', teeth: '45', detail: { item: '코핑', material: 'CoCr', qty: 1 }, status: 'received', jig: null, recv: -1, due: 2, downloaded: false, note: '' },
    { n: 7, lab: 'lab1', kind: 'cnc', teeth: '16', detail: cnc('Osstem TS III', 'Hex', 'Wide', '5.0'), status: 'milling', jig: 'ready', recv: -3, due: -1, downloaded: true, note: '' },
    { n: 8, lab: 'lab5', kind: 'zirconia', teeth: '47', detail: { item: '풀 지르코니아', material: '다층', shade: 'A2', qty: 1 }, status: 'received', jig: null, recv: 0, due: 4, downloaded: false, note: '첫 의뢰입니다. 잘 부탁드립니다.' },
    { n: 9, lab: 'lab3', kind: 'cnc', teeth: '24', detail: cnc('Dentium SuperLine', 'Hex', 'Regular', '4.0'), status: 'shipped', jig: 'ready', recv: -4, due: -1, downloaded: true, note: '', ship: -1, tracking: '6342-1187-9920' },
    { n: 10, lab: 'lab2', kind: 'metal', teeth: '35,36,37', bridge: true, detail: { item: '프레임', material: 'Ti', qty: 1 }, status: 'shipped', jig: null, recv: -5, due: -2, downloaded: true, note: '', ship: -2, tracking: '6342-1187-9871' },
    { n: 11, lab: 'lab1', kind: 'cnc', teeth: '14', detail: cnc('Neo IS-III', 'Non-hex', 'Narrow', '4.0'), status: 'milling', jig: 'ready', recv: -4, due: -2, downloaded: true, note: '' },
    { n: 12, lab: 'lab4', kind: 'cnc', teeth: '35', detail: cnc('Osstem TS III', 'Hex', 'Regular', '4.0'), status: 'shipped', jig: 'ready', recv: -6, due: -3, downloaded: true, note: '', ship: -3, tracking: '' },
];

// 스크롤·명세서 확인용 추가 샘플 18건 — 고정 규칙으로 만들어 새로고침해도 같은 값
const SYSTEMS = [['Osstem TS III', 'Regular', '4.5'], ['Straumann BLT', 'RC', '4.1'], ['Dentium SuperLine', 'Regular', '4.5'], ['Neo IS-III', 'Regular', '4.0'], ['Megagen AnyRidge', 'Regular', '4.4']];
const LABS = ['lab1', 'lab2', 'lab3', 'lab4', 'lab5', 'lab1', 'lab2'];
const TEETH = ['36', '46', '26', '16', '37', '47', '15', '25', '44'];
for (let i = 0; i < 18; i += 1) {
    const n = 13 + i;
    const shipped = i < 10;                       // 앞 10건 = 이번 달 출고(명세서 항목)
    const kindPick = i % 6 === 2 ? 'metal' : i % 6 === 5 ? 'zirconia' : 'cnc';
    const [sys, plat, dia] = SYSTEMS[i % SYSTEMS.length];
    const detail = kindPick === 'cnc' ? cnc(sys, i % 4 === 3 ? 'Non-hex' : 'Hex', plat, dia)
        : kindPick === 'metal' ? { item: i % 2 ? '코핑' : '프레임', material: i % 3 ? 'CoCr' : 'Ti', qty: 1 }
            : { item: '풀 지르코니아', material: '다층', shade: 'A2', qty: 1 };
    const recv = shipped ? -(7 + i) : -(i % 3);
    RAW.push({
        n, lab: LABS[i % LABS.length], kind: kindPick, teeth: TEETH[i % TEETH.length], detail,
        status: shipped ? 'shipped' : (i % 2 ? 'milling' : 'received'),
        jig: kindPick === 'cnc' ? 'ready' : null,
        recv, due: shipped ? recv + 3 : 3 + (i % 5), downloaded: shipped || i % 2 === 1, note: i % 5 === 0 ? '마진 라인 확인 부탁드립니다.' : '',
        ship: shipped ? recv + 2 : undefined, tracking: shipped && i % 3 ? `6342-1190-${String(1000 + i * 37).slice(-4)}` : '',
    });
}

const REMAKE = {
    10: { reason: '연결부가 헐거움 — 임플란트에 체결 시 흔들림', photos: 2, at: at(-1, 11), status: 'requested' },
    12: { reason: '마진 높이 0.5mm 낮게 요청했으나 반영 안 됨', photos: 1, at: at(-2, 15), status: 'free' },
};
// 환자 이름(가상 인물) — 제조사 화면은 케이스를 환자 이름으로 부른다(대표 10-23). 각인·파일명·명세서는 번호 유지
const PATIENTS = ['홍길동', '김영희', '이철수', '박민지', '최준호', '정수빈', '강하늘', '윤서연', '임도현', '한지우'];
// CNC 업체 실명 표시 — 미리보기 전용 샘플 값(대표 10-23 「미리보기에서만 CNC 이름 보이게」).
//   운영 스위치 config/features.outsourceMfCncName 은 그대로 OFF(약관 v7.1·변호사 확인 전). 실데이터 연결 시 이 상수는 버리고
//   readVendorPatientName(rules가 기한·CNC 스위치로 판정) 결과로 표시한다.
export const CNC_NAME_ON = true;

const UNIT_PRICE = { cnc: 55000, metal: 38000, zirconia: 45000, general: 40000, etc: 0 };

const ymd = (d) => `${String(d.getFullYear()).slice(2)}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;

export function makeSampleCases() {
    return RAW.map((r) => {
        const receivedAt = at(r.recv, 9 + (r.n % 6));
        return {
            id: `sample-${r.n}`,
            caseNo: `MF-${ymd(receivedAt)}-${String(r.n).padStart(3, '0')}`,
            labId: r.lab,
            labName: labName(r.lab),
            kind: r.kind,
            teeth: r.teeth,
            bridge: !!r.bridge,
            detail: r.detail,
            note: r.note,
            status: r.status,
            jig: r.jig,
            jigFailReason: r.jigFail || '',
            receivedAt,
            dueAt: at(r.due, 18),
            shippedAt: r.ship != null ? at(r.ship, 16) : null,
            trackingNo: r.tracking || '',
            downloaded: r.downloaded,
            unitPrice: UNIT_PRICE[r.kind] || 0,
            // 재제작·클레임 — 기공소가 출고된 건에 재제작을 요청(사유·사진), 제조사가 무상/유상 판정(문헌 조사 10-23: 플랫폼 안 편익)
            remake: REMAKE[r.n] || null,
            patientName: PATIENTS[(r.n - 1) % PATIENTS.length],
        };
    });
}

// 알림 종 — 신규 도착 / 납기 임박 / 지그 실패 / 묶음 소진 임박 / 출고 미확인
export const SAMPLE_NOTIFICATIONS = [
    { id: 'n1', kind: 'new', text: '신규 케이스 3건이 도착했습니다', at: at(0, 9) },
    { id: 'n2', kind: 'due', text: '납기 D-1 케이스 2건 — 오늘 출고 필요', at: at(0, 8) },
    { id: 'n3', kind: 'jigFail', text: 'MF 케이스 1건 지그 생성 실패 (수동 확인)', at: at(0, 7) },
    { id: 'n4', kind: 'unshipped', text: '밀링 중 3일 지난 케이스 1건 — 출고 처리를 확인해 주세요', at: at(-1, 18) },
    { id: 'n5', kind: 'quota', text: '이번 달 지그 묶음 80% 사용', at: at(-2, 10) },
];

export const SAMPLE_USAGE = { used: 1240, cap: 1500, newLabsThisMonth: 2 };

// 정산 — 덴클 청구(덴클 → 제조사)
export const SAMPLE_DENCL_BILLS = [
    { month: '2026-10', jigCount: 1240, plan: '묶음 1,500개', amount: null, status: '진행 중' },
    { month: '2026-09', jigCount: 1388, plan: '묶음 1,500개', amount: 495000, status: '청구 완료' },
    { month: '2026-08', jigCount: 1102, plan: '묶음 1,500개', amount: 495000, status: '청구 완료' },
];

// 정산 — 영업업체 추천코드별 물량
// 영업업체 — 제조사가 직접 등록·관리하는 영업 파트너(덴클 계정 없음, 대표 10-23 「영업사는 없어지고 제조사에게 정산받는 게 맞다」)
// 제조사가 영업업체마다 추천코드를 주고, 기공소가 가입할 때 그 코드를 넣으면 「○○ 소개」로 잡힌다. 수수료는 제조사가 직접 정산.
export const SAMPLE_SALES = [
    { id: 's1', code: 'S-A01XYZ', name: 'A덴탈영업', since: at(-150) },
    { id: 's2', code: 'S-B07QWE', name: 'B영업', since: at(-60) },
]

export const SAMPLE_MANAGERS = [
    { id: 'm1', name: '김담당', role: '대표', phone: '010-****-1234', notify: true },
    { id: 'm2', name: '이밀링', role: '밀링 담당', phone: '010-****-5678', notify: true },
    { id: 'm3', name: '박출고', role: '출고 담당', phone: '010-****-9012', notify: false },
];
